export default "__VITE_ASSET__DEolEG0J__"